<script setup lang="ts">
import {useRandomUUID} from "~/composables/useRandomUUID";
import {onMounted, ref} from "vue";
import {
  breakpointsTailwind,
  useBreakpoints,
} from "@vueuse/core";
const count=ref(0)
type Props = {
  open?:boolean,
  dataTestid?:string
};
const props = withDefaults(defineProps<Props>(), {
  open:false,
});
const random_id = ref<string>("");

onMounted(() => {
  random_id.value = useRandomUUID();
});
const breakpoints = useBreakpoints(breakpointsTailwind);

const mdAndSmaller = breakpoints.smallerOrEqual("md");

const wrapperComponent = computed<any>(() =>
    mdAndSmaller.value ? false : props.open
);
</script>

<template>
  <div :id="'accordion-' + random_id" :data-accordion="wrapperComponent?'open':'collapse'" :data-testid="props.dataTestid"
       data-active-classes="!text-idle-black !mb-0 rounded-b-none" >
    <slot></slot>
  </div>
</template>
